export const APP_NAME = 'Incident Report'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export const INCIDENT_TYPES = [{
  label: 'Positive',
  value: 'positive'
}, {
  label: 'Near Miss',
  value: 'near_miss'
}, {
  label: 'Unsafe Act',
  value: 'unsafe_act'
}, {
  label: 'Unsafe Condition',
  value: 'unsafe_condition'
}]

export const PERSONNEL = [{
  label: 'Alan Whittaker',
  value: 'Alan Whittaker'
}, {
  label: 'Alex Bullock',
  value: 'Alex Bullock'
}, {
  label: 'Alex Watson',
  value: 'Alex Watson'
}, {
  label: 'Billy Cooper',
  value: 'Billy Cooper'
}, {
  label: 'David Gorvett',
  value: 'David Gorvett'
}, {
  label: 'Fransiscus Van Geijlswijk',
  value: 'Fransiscus Van Geijlswijk'
}, {
  label: 'Ian Weightman',
  value: 'Ian Weightman'
}, {
  label: 'James Fielding',
  value: 'James Fielding'
}, {
  label: 'Jamie Blackburne',
  value: 'Jamie Blackburne'
}, {
  label: 'Joe Mortimer',
  value: 'Joe Mortimer'
}, {
  label: 'John Monaghan',
  value: 'John Monaghan'
}, {
  label: 'Johnathan Howard',
  value: 'Johnathan Howard'
}, {
  label: 'Josh Franks',
  value: 'Josh Franks'
}, {
  label: 'Josh Hardy',
  value: 'Josh Hardy'
}, {
  label: 'Kristian Hassall',
  value: 'Kristian Hassall'
}, {
  label: 'Louie Staffa',
  value: 'Louie Staffa'
}, {
  label: 'Matt Ellis',
  value: 'Matt Ellis'
}, {
  label: 'Matt Milburn',
  value: 'Matt Milburn'
}, {
  label: 'Phil Surridge',
  value: 'Phil Surridge'
}, {
  label: 'Rosa Santos',
  value: 'Rosa Santos'
}, {
  label: 'Stephen Yates',
  value: 'Stephen Yates'
}, {
  label: 'Tony Priestley',
  value: 'Tony Priestley'
}, {
  label: 'Unkowns',
  value: 'Unkowns'
}]
